/**
 * 언어 전환기 — **F-D2 의 파생 요구**(구 앱에 없어서 en/ja 가 사문화됐던 것).
 *
 * 전환은 즉시 반영되고 선택은 로컬에 남는다. 서버에 보내지 않는 이유: 언어는 계정 속성이
 * 아니라 **그 브라우저에서 보는 방식**이고, 서버에 두면 계정 스키마·감사에 개인 설정이 섞인다.
 */
import { useTranslation } from 'react-i18next'

import { LOCALES, setLocale } from './index'
import type { LocaleCode } from './index'

export function LocaleSwitcher() {
  const { i18n, t } = useTranslation()

  return (
    <label className="flex min-w-0 items-center gap-1 text-xs text-ink-3">
      <span className="sr-only">{t('nav.language')}</span>
      {/* 사이드바 바닥은 288px 안에 아바타·이름·아이콘 둘과 함께 산다 — 여기서만 좁게 쓴다. */}
      <select
        value={i18n.language}
        onChange={(event) => setLocale(event.target.value as LocaleCode)}
        aria-label={t('nav.language')}
        className="locale-select"
      >
        {LOCALES.map((locale) => (
          <option key={locale.code} value={locale.code}>
            {locale.label}
          </option>
        ))}
      </select>
    </label>
  )
}
